const ded = `
<h1>Política de Uso de la Inteligencia Artificial (IA) en la Plataforma DressDown</h1>

<h2>Cumplimiento de la Legislación de la UE</h2>
<p>DressDown cumple con las normas legales de la Unión Europea, incluyendo:</p>
<ul>
  <li>Reglamento General de Protección de Datos (RGPD): en el tratamiento de datos personales.</li>
  <li>Reglamento de Inteligencia Artificial (AI Act): en el uso e implementación de sistemas de IA.</li>
  <li>Carta de los Derechos Fundamentales de la Unión Europea: en particular los artículos 7 (respeto a la vida privada y familiar) y 8 (protección de los datos personales).</li>
</ul>

<h2>Transparencia y Etiquetado del Contenido Generado por IA</h2>
<p>Todas las imágenes creadas con tecnologías de inteligencia artificial deben ir acompañadas obligatoriamente del siguiente aviso:</p>
<p><strong>Generado por IA. No es una fotografía real. Cualquier coincidencia es pura casualidad.</strong></p>
<p>Esta práctica garantiza la transparencia y la información adecuada para los usuarios, y se ajusta a los principios de equidad y honestidad consagrados en la legislación de la UE, en particular en el Reglamento (UE) 2019/1150 sobre la promoción de la equidad y la transparencia para los usuarios profesionales de plataformas en línea, así como en el Código de Buenas Prácticas contra la Desinformación recomendado por la Comisión Europea. Se presta especial atención al etiquetado de contenidos que puedan percibirse como periodísticos, científicos o de relevancia política, para evitar la difusión de desinformación y proteger el derecho de los usuarios a recibir información veraz conforme al artículo 11 de la Carta de los Derechos Fundamentales (libertad de expresión).</p>

<h2>Consentimiento y Protección de la Privacidad</h2>
<ul>
  <li>Está prohibido el uso de imágenes reales de personas sin su consentimiento expreso, incluyendo:
    <ul>
      <li>Fotos de cuentas personales.</li>
      <li>Datos biométricos.</li>
      <li>Imágenes médicas e íntimas.</li>
    </ul>
  </li>
  <li>No almacenamos ni utilizamos datos personales sensibles en sistemas generativos.</li>
</ul>

<h2>Restricciones sobre Contenidos Perjudiciales</h2>
<p>Está prohibido utilizar los sistemas de IA de DressDown para generar o difundir:</p>
<ul>
  <li>Contenido con elementos de discriminación, racismo, sexismo u otras formas de odio.</li>
  <li>Imágenes violentas, pornográficas o difamatorias.</li>
  <li>Desinformación o deepfakes que engañen o dañen la reputación.</li>
</ul>

<h2>Restricciones Éticas y Moderación</h2>
<ul>
  <li>Las solicitudes que violen normas sociales o puedan causar daño social se bloquean automáticamente.</li>
  <li>Existe un sistema de moderación: las acciones sospechosas pueden ser revisadas manualmente.</li>
  <li>El contenido que infrinja la política será eliminado y los infractores, bloqueados.</li>
</ul>

<h2>Protección de Derechos de Autor</h2>
<ul>
  <li>La generación de imágenes no debe replicar estilos reconocibles de artistas o fotógrafos sin su permiso.</li>
  <li>Está prohibido crear obras que puedan infringir derechos de propiedad intelectual de terceros.</li>
</ul>

<h2>Medidas Técnicas de Protección</h2>
<p>DressDown.me aplica un conjunto completo de medidas técnicas y organizativas para garantizar la seguridad en el tratamiento de datos relacionados con el uso de tecnologías de IA. Estas medidas buscan proteger los datos personales del usuario contra accesos no autorizados, pérdida, alteración o divulgación, y asegurar el cumplimiento legal.</p>
<p>Las medidas clave incluyen:</p>
<ul>
  <li>Cifrado de datos durante la transmisión y almacenamiento con protocolos de seguridad modernos como TLS/SSL, conforme a las recomendaciones de la Agencia de la UE para la Ciberseguridad (ENISA).</li>
  <li>Restricción de acceso a los sistemas de IA y a los datos personales sólo al personal autorizado y socios que se comprometan a la confidencialidad, de acuerdo con el artículo 32 del RGPD (Seguridad del tratamiento).</li>
  <li>Actualización regular del software y hardware para eliminar vulnerabilidades y prevenir ciberataques.</li>
  <li>Monitoreo, auditoría y pruebas constantes de los sistemas de seguridad para detectar y responder a incidentes, conforme a la norma ISO/IEC 27001 sobre gestión de seguridad de la información.</li>
  <li>Cumplimiento de los requisitos del RGPD (Reglamento (UE) 2016/679) y demás normativa aplicable de la UE.</li>
</ul>
<p>El tratamiento de datos con IA se realiza conforme a los principios de minimización de datos (art. 5 RGPD) y limitación de la finalidad, y los datos no se conservan más tiempo del necesario para cumplir con los fines del tratamiento.</p>

<h2>Sus Derechos</h2>
<p>De acuerdo con el RGPD, los usuarios tienen derecho a:</p>
<ul>
  <li>Acceder a sus datos.</li>
  <li>Retirar el consentimiento para su tratamiento.</li>
  <li>Solicitar la eliminación o corrección de los datos relacionados con la generación de imágenes.</li>
</ul>
<p>Si cree que su contenido, imagen o datos se han utilizado sin consentimiento, puede contactarnos en: <a href="mailto:dressdown@dressdown.me">dressdown@dressdown.me</a>. Garantizamos revisión y respuesta en un plazo de 30 días naturales.</p>
`;

export default ded
